<template>
    <div class="ml-4">
        <h1 class="text-muted mb-4">
            <vue-fontawesome class="mr-2" icon="sort"></vue-fontawesome>        
            <router-link class="ml-2 text-decoration-none"
                :to="{ name: `stock`, query: { destroy : destroy }}">
                <i class="ml-2 arrow left" style="height:25px;width:25px"></i>
                Stock
            </router-link>   
            / {{stock.product.name}}
        </h1>
            
        <div>
            <div class="d-flex justify-content-between">
                <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" 
                                id="pills-home-tab" 
                                data-toggle="pill" 
                                href="#pills-home" 
                                role="tab" 
                                aria-controls="pills-home" 
                                aria-selected="true">
                                                        
                                Stock per location
                            </a>
                        </li>                                                						
                </ul>
                <!-- add buttons -->                
            </div>									
            <div class="tab-content" id="pills-tabContent">
                <div class="tab-pane fade show active" 
                    id="pills-home" 
                    role="tabpanel" 
                    aria-labelledby="pills-home-tab"> 
                    <div class="d-flex justify-content-start">                                            
                        <div class="col-lg-12 rounded shadow">
                            <table class="table table-borderless table-responsive-sm">
                                    <thead>
                                        <tr>                                            
                                        <th scope="col">Store</th>                                        
                                        <th scope="col">Units</th>
                                        <th scope="col"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(location,index) in stock.locations" :key="index">                                                
                                            <td>{{location.name}}</td>                                           
                                            <td>{{location.total}}</td>
                                            <td>
                                                <span class="p-2 rounded shadow hidden mt-0" style="position:absolute;right: 0px;">                                                
                                                    <span class="d-flex mr-4">
                                                        <span class="btn btn-sm btn-success" data-toggle="modal" data-target="#transferStockModal"
                                                            @click="selectLocation(location)">
                                                            transfer stock                                           
                                                        </span>										
                                                        <span class="ml-2 btn btn-sm btn-success" data-toggle="modal" data-target="#adjustStockModal"
                                                            @click="selectLocation(location)">
                                                            adjust stock                                           
                                                        </span>	
                                                    </span>                                                      
                                                </span>
                                            </td>
                                        </tr>                                          
                                    </tbody>
                            </table>
                        </div>
                    </div>                                                                                     
                </div>                               
            </div> 		  
        </div>	
        <!-- modals -->
        <section>
            <!-- transfer stock -->
            <div class="modal fade" id="transferStockModal" tabindex="-1" role="dialog" aria-labelledby="transferStockModal" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document" v-if="location">
                    <div class="modal-content">
                    <div class="modal-header border-0">
                        <h5 class="modal-title" id="exampleModalCenterTitle">                            
                            Transfer stock for {{stock.product.name}} | {{location.variant_name}}<br/>
                            <small><b>{{location.total}}</b> units available in {{location.name}}</small>
                        </h5>
                        <button type="button" id="closeTransferStockModal" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <form id="transferStockForm">
                        <div class="modal-body">                    
                                <div class="p-3 d-flex justify-content-between">
                                    <label class="font-weight-bold">Transfer Date</label>
                                    <input type="date" class="col-8 form-control" v-model="stock_transfer.date" required>
                                </div>     
                                <div class="p-3 d-flex justify-content-between">
                                    <label class="font-weight-bold">From</label>
                                    <select class="col-8 form-control" v-model="location.id" disabled>                                        
                                        <option v-for="(location,index) in locations" :key="index" :value="location.id">
                                            {{location.name}}
                                        </option>
                                    </select>
                                </div>
                                <div class="p-3 d-flex justify-content-between">
                                    <label class="font-weight-bold">To</label>
                                    <select class="col-8 form-control" v-model="stock_transfer.to_location" required>
                                        <option v-for="(location,index) in other_locations" :key="index" :value="location.id">
                                            {{location.name}}
                                        </option>
                                    </select>
                                </div>
                                <div class="p-3 d-flex justify-content-between">
                                    <label class="font-weight-bold">Units</label>
                                    <input type="number" class="col-8 form-control" v-model="stock_transfer.quantity" required>
                                </div>  
                                <div class="p-3 d-flex justify-content-between">
                                    <label class="font-weight-bold">Reason</label>
                                    <textarea rows="3" class="col-8 form-control" placeholder="Reason for transferring stock" v-model="stock_transfer.reason"></textarea>                                    
                                </div>                                                                                                                                           
                        </div>
                        <div class="modal-footer border-0">                            
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                            <button type="submit" class="btn btn-success"
                                @click="transferStock()">                                                        
                                Transfer stock
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="updating"></span>
                            </button>
                        </div>
                    </form>                
                    </div>
                </div>
            </div>
            <!-- adjust stock -->
            <div class="modal fade" id="adjustStockModal" tabindex="-1" role="dialog" aria-labelledby="adjustStockModal" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document" v-if="location">
                        <div class="modal-content">
                        <div class="modal-header border-0">
                            <h5 class="modal-title" id="exampleModalCenterTitle">                            
                                Adjust stock for {{stock.product.name}} | {{location.variant_name}}<br/>                             
                            </h5>
                            <button type="button" id="closeAdjustStockModal" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <form id="adjustStockForm">
                            <div class="modal-body">                    
                                    <div class="p-3 d-flex justify-content-between">
                                        <label class="font-weight-bold">Adjustment Date</label>
                                        <input type="date" class="col-8 form-control" v-model="stock_adjustment.date" required>
                                    </div>   
                                    <div class="p-3 d-flex justify-content-between">
                                        <label class="font-weight-bold">Units available</label>
                                        <input type="number" class="col-8 form-control" v-model="location.total" disabled>
                                    </div>                                                                         
                                    <div class="p-3 d-flex justify-content-between">
                                        <label class="font-weight-bold">New units</label>
                                        <input type="number" class="col-8 form-control" v-model="stock_adjustment.quantity" required>
                                    </div>  
                                    <div class="p-3 d-flex justify-content-between">
                                        <label class="font-weight-bold">Reason</label>
                                        <textarea rows="3" class="col-8 form-control" placeholder="Reason for adjusting stock" v-model="stock_adjustment.reason"></textarea>                                    
                                    </div>                                                                                                                                           
                            </div>
                            <div class="modal-footer border-0">                            
                                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                                <button type="submit" class="btn btn-success"
                                    @click="adjustStock()">                                                        
                                    Adjust stock
                                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="updating"></span>
                                </button>
                            </div>
                        </form>                
                        </div>
                    </div>
                </div>
        </section>
    </div>
</template>
<script>
export default {
    name: 'stockDetail',    
    data(){
        return{            
            stock : this.$route.query.stock,     
            locations:null,
            //selected location
            location: null,
            stock_transfer:{
                date : this.$moment().format('YYYY-MM-DD') 
            },
            stock_adjustment:{
                date : this.$moment().format('YYYY-MM-DD') 
            },
            updating : false,
            //whether to destroy stock component (if an update is made 
            //here then it has to be destroyed as it would have wrong details)
            destroy: false
        }
    },  
    mounted(){
        this.getLocations()
    },
    computed:{     
        account_switched(){
            return this.$store.state.account_switch_count
        }
    },
    watch:{
        account_switched: function(){
            this.$route.push("/stock")
        }
    },
    methods:{		        
        //locations types for when adding
        getLocations: function(){                            
            this.$http({
                method:'get',				
                url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/locations/`,
                headers:{
                    Authorization: JSON.parse(localStorage.getItem('auth_token'))
                },                
            }).then((response)=>{
                this.locations = response.data
            }).catch((err)=>{
                alert(err)
            })
        },       
        //select location
        selectLocation: function(location){
            this.location = location             
            //locations not selected
            this.other_locations   = this.locations.filter((location)=>{ 
                return location.id != this.location.id
            })        
        },
        //transfer stock
        transferStock: function(){
            var is_valid = document.getElementById('transferStockForm').checkValidity()
            if(is_valid){
                this.updating = true
                this.$http({
                    method:'post',				
                    url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/transfer/`,
                    headers:{
                        Authorization: JSON.parse(localStorage.getItem('auth_token'))
                    },                
                    data:{
                        transfer: {                            
                            date: this.stock_transfer.date,
                            reason: this.stock_transfer.reason || 'None given',
                            quantity: this.stock_transfer.quantity,
                            product: this.stock.product.id,
                            product_name: this.stock.product.name,
                            variant_id: this.location.variant
                        },
                        from_id: this.location.id,
                        to_id: this.stock_transfer.to_location
                    }
                }).then(()=>{
                    this.updating = false                    
                    //update data for where stock is from
                    var location_index = this.stock.locations.findIndex((x)=>{ return x.id === this.location.id})
                    var total = this.stock.locations[location_index].total            
                    var new_total = parseInt(total) - parseInt(this.stock_transfer.quantity)          
                    this.stock.locations[location_index].total = new_total    
                    //update data for where stock is going.
                    location_index = this.stock.locations.findIndex((x)=>{ return x.id === this.stock_transfer.to_location})
                    total = this.stock.locations[location_index].total            
                    new_total = parseInt(total) + parseInt(this.stock_transfer.quantity)          
                    this.stock.locations[location_index].total = new_total   

                    this.stock_transfer = {}
                    this.stock_transfer.date = this.$moment().format('YYYY-MM-DD')
                    document.getElementById('closeTransferStockModal').click()                                                            
                }).catch((err)=>{
                    this.updating = false
                    alert(err)
                })
            }         
        },
        //adjust stock
        adjustStock: function(){            
            var is_valid = document.getElementById('adjustStockForm').checkValidity()
            if(is_valid){
                this.updating = true
                this.$http({
                    method:'post',				
                    url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/stock-count/`,
                    headers:{
                        Authorization: JSON.parse(localStorage.getItem('auth_token'))
                    },                
                    data:{
                        item: this.stock.product.id,
                        location: this.location.id,
                        new_count: this.stock_adjustment.quantity                        
                    }
                }).then(()=>{
                    this.updating = false                    
                    //update data for where stock is from
                    var location_index = this.stock.locations.findIndex((x)=>{ return x.id === this.location.id})                                                            
                    this.stock.locations[location_index].total = parseInt(this.stock_adjustment.quantity)
                    //update data for where stock is going.                   

                    this.stock_adjustment = {}
                    this.stock_adjustment.date = this.$moment().format('YYYY-MM-DD')
                    document.getElementById('closeAdjustStockModal').click()                                                            
                    this.destroy = true
                }).catch((err)=>{
                    this.updating = false
                    alert(err)
                })
            }         
        }
    }
}
</script>